const properties = [
  {
    id: 1,
    name: '港区高輪タワーレジデンス',
    price: '1億2,800万円',
    location: '東京都港区高輪',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20modern%20high-rise%20apartment%20building%20exterior%20in%20Tokyo%20Minato%20ward%20with%20glass%20facade%20and%20contemporary%20architecture%2C%20professional%20real%20estate%20photography%20with%20clean%20simple%20white%20background%2C%20bright%20natural%20daylight%2C%20minimalist%20composition%20highlighting%20the%20elegant%20tower%20structure&width=800&height=600&seq=prop-001&orientation=landscape',
    type: '分譲マンション'
  },
  {
    id: 2,
    name: '世田谷区成城邸宅',
    price: '9,500万円',
    location: '東京都世田谷区成城',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Japanese%20modern%20detached%20house%20with%20minimalist%20design%20and%20wooden%20accents%20in%20upscale%20residential%20area%2C%20professional%20real%20estate%20photography%20with%20clean%20simple%20white%20background%2C%20natural%20daylight%20showcasing%20architectural%20details%2C%20contemporary%20single-family%20home%20exterior&width=800&height=600&seq=prop-002&orientation=landscape',
    type: '一戸建て'
  },
  {
    id: 3,
    name: '横浜みなとみらいタワー',
    price: '7,200万円',
    location: '神奈川県横浜市西区',
    image: 'https://readdy.ai/api/search-image?query=Modern%20waterfront%20condominium%20tower%20in%20Yokohama%20Minato%20Mirai%20with%20sleek%20glass%20exterior%20and%20bay%20views%2C%20professional%20real%20estate%20photography%20with%20clean%20simple%20white%20background%2C%20bright%20daylight%2C%20contemporary%20urban%20residential%20architecture&width=800&height=600&seq=prop-003&orientation=landscape',
    type: '分譲マンション'
  }
];

export default function PropertyGrid() {
  return (
    <section className="py-32 bg-gradient-to-b from-white to-slate-50">
      <div className="max-w-7xl mx-auto px-8">
        <div className="mb-20">
          <h2 className="text-6xl font-serif leading-tight">
            <span className="text-slate-900">厳選された</span><br />
            <span className="text-amber-600">優良物件</span>
          </h2>
        </div>

        <div className="grid grid-cols-3 gap-8" data-product-shop>
          {properties.map((property) => (
            <div
              key={property.id}
              className="bg-white rounded-2xl border border-slate-200 overflow-hidden hover:shadow-xl transition-all duration-300 group"
            >
              <div className="relative h-80 bg-white overflow-hidden">
                <img
                  src={property.image}
                  alt={property.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4 bg-slate-900/80 backdrop-blur-sm text-white px-4 py-1.5 rounded-full text-xs font-medium">
                  {property.type}
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-serif text-slate-900 mb-3">{property.name}</h3>
                <p className="text-3xl font-bold text-amber-600 mb-3">{property.price}</p>
                <p className="text-sm text-slate-500 mb-4">
                  <i className="ri-map-pin-line mr-1"></i>
                  {property.location}
                </p>
                <div className="inline-flex items-center gap-2 text-sm text-slate-700 font-medium cursor-default">
                  詳細を見る
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-16">
          <button className="inline-flex items-center gap-3 px-8 py-4 bg-slate-900 text-white rounded-lg font-medium whitespace-nowrap cursor-default">
            すべての物件を見る
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
